import { render, staticRenderFns } from "./JoinEvents.vue?vue&type=template&id=c57fb6f8&"
import script from "./JoinEvents.vue?vue&type=script&lang=js&"
export * from "./JoinEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports